module.exports = __webpack_public_path__ + "static/media/gcdef_10025.43609a09.ico";